var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digital-interface"},[_c(_vm.digitFirst,{tag:"component"}),_c(_vm.digitSecond,{tag:"component"}),_vm._t("default",[_c('icon-colon')]),_c(_vm.digitThird,{tag:"component"}),_c(_vm.digitFourth,{tag:"component"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }